<template>
    <Layout>
      <div class="row">
        <div class="col-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card">
                    <!-- <div class="card-header bg-primary rounded-1 text-white">{{ service }}</div> -->
                    <div class="card-header bg-primary rounded-1 text-white" v-if ="isPaymentTypeValid">{{ service }}</div>
                    <div class="card-header bg-primary rounded-1 text-white" v-else >{{ insuranceservice }}</div>

                    <div class="card-body p-2">
                      <div class=" mb-2 d-flex justify-content-between">
                        <!-- <img class="img-rounded" src="@/assets/images/sick.png" height="70px" /> -->
                        <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                      </div>
                      <span v-if="patientspinner==false">
                      <table v-for="item in patients" :key="item.id" class="table">
                        <img class="img-rounded" :src="getPhotos(item.photo)" height="50px" />
                      <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.name }} </b></td></tr>
                      <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.gender }} </span></td></tr>
                      <tr><td> Telephone </td><td> <span class="text-primary h7">0{{ item.telephone }} </span></td></tr>
                      <tr><td> Age </td><td> <span class="text-primary h7">{{ getAge(item.date_of_birth) }}  </span></td></tr>
                      <tr><td> Address </td><td> <span class="text-primary h7">{{ item.address }} </span></td></tr>
                      <tr><td> Nationality </td><td> <span class="text-primary h7">{{ item.nationality }} </span></td></tr>

                    </table>
                      <h5 class="my-3"><i class="mdi mdi-calendar"></i> &nbsp;&nbsp; {{ visit_date }}</h5>

                      </span>
                      <span v-else>
                        <i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i> 
                      </span>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <b-tabs pills nav-class="p-0" content-class="text-dark">
                      <b-tab active class="border-0">
                        <template v-slot:title>Treatment</template>
                        <div class="card">
                          <div class="card-body">
                            <span v-if="antenatalcard==''">
                            <form @submit.prevent="addAntenatalCard">
                            <div class="row gy-2 gx-2 align-items-center">
                            <div class="col-auto">
                                <label>Upload Antenatal Card</label>
                                <input type="file" class="form-control" v-on:change="onFileChange">
                            </div>
                            <div class="col-auto">
                                <b-button variant="primary" type="submit" class="w-md mt-4">Upload</b-button>
                            </div>
                            </div>
                            </form>
                            </span>
                            <span v-else>
                            <div v-for="item in antenatalcard" :key="item.id">
                                <i class="mdi mdi-file-outline text-primary h1"></i> &nbsp; &nbsp;
                                <span class="h5 text-primary">Antenatal Card</span>&nbsp; &nbsp;
                                <a :href="getFiles(item.card_label)" download="" class="btn btn-sm btn-primary"> <i class="mdi mdi-download"></i> </a>&nbsp; &nbsp;
                                <a target="_blank" :href="getFiles(item.card_label)" class="btn btn-sm btn-danger"> <i class="mdi mdi-eye"></i> </a>
                            </div>
                            </span>
                            <br>
                              <form @submit.prevent="addTreatment">
                                <label class="mt-2">Comments / Findings</label>
                                <tinymce id="d1" v-model="diagnosis"></tinymce>
                                <div class="form-group d-flex justify-content-end mt-3">
                                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
                                </div>
                              </form>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab class="border-0">
                          <template v-slot:title>Presciptions</template>
                          <div class="card">
                            <div class="card-body">
                              <b-button v-b-modal.new-prescription size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Prescription</b-button>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Medicine</th><th>Dosage</th><th>Note</th><th>Status</th></tr></thead>
                              <tbody>
                                <tr v-for="item in prescriptions" :key="item.id">
                                    <td>{{ item.medicine.name }} </td>
                                    <td>{{ item.dosage }}</td>
                                    <td>{{ item.note }}</td>
                                    <td>
                                      <span v-if="item.status==1">
                                        <b-button @click="deleti(item.id,item.medicine.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                                      </span>
                                      <span v-else>
                                        <b-button type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-check-circle"></i></b-button>
                                      </span>
                                      &nbsp;
                                      <span v-if="item.status==2">
                                        <b-button @click="changes(item.id,item.medicine.name,item.dosage)" type="button" class="btn-sm btn" variant="info"  v-b-modal.change> <i class="mdi mdi-square-edit-outline"></i> </b-button>

                                      </span>
                                    </td>
                                </tr>
                              </tbody>
                              </table>
                            </div>
                          </div>
                      </b-tab>
                      <b-tab class="border-0">
                        <template v-slot:title>Services</template>
                        <div class="card">
                          <div class="card-body">
                              <b-button v-b-modal.new-service size="sm" variant="primary"><i class="mdi mdi-plus"></i> Add a Service</b-button>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th><th>Status</th></tr></thead>
                              <tbody>

                                <tr v-for="item in services" :key="item.id">
                                    <td>{{ item.service_category ? item.service_category.name : 'N/A' }}</td>
                                    <td v-if ="isPaymentTypeValid">{{ item.service_name.name  }}</td>
                                    <td v-else>{{ item.insurance_service_name.name  }}</td>

                                    <!-- <td>{{ item.service_name && item.service_name.name ? item.service_name.name : (item.insurance_service_name && item.insurance_service_name.name ? item.insurance_service_name.name : '') }}</td> -->
                                    <td>{{ item.service_price }}</td>
                                    <td>
                                      <span v-if="item.status==1">
                                        <span class="btn btn-sm btn-dark">Pending</span>
                                      </span>
                                      <span v-else>
                                        <b-button @click="edit(item.service_name ? item.service_name.id : item.insurance_service_name.id, 
                                        item.service_name ? item.service_name.name : item.insurance_service_name.name)" 
                                        type="button" class="btn-sm btn" variant="primary" v-b-modal.edit>
                                        <i class="mdi mdi-clipboard-list"></i> results</b-button>
                                      </span>
                                    </td>
                                    <!-- <td>{{ item.payment_types }}</td> -->
                                </tr>
                              </tbody>
                              </table>
                              
                              
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
        </div>
      </div>
      

      <b-modal id="new-service" size="md" title="New Service" title-class="font-14" hide-footer>
    <template v-if="isPaymentTypeValid">
      
            <!-- Default form for other users -->
        <form @submit.prevent="AddPatientService">
            <div class="form-group mb-2">
                <label>Service Category </label> <small class="text-danger">*</small>
                <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
                <label>Service Name</label> <small class="text-danger">*</small>
                <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
            </div>
            <div class="form-group mb-2">
                <label>Service Cost</label> <small class="text-danger">*</small>
                <input v-model="service_price" readonly required type="number" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')">Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </template>
    <template v-else>
    
        <form @submit.prevent="AddPatientService">
           
              <!-- Form for users with payment_types=4 insurance -->
          
                    
                    
                    <div class="form-group mb-2" >
                      <label>Service Category</label> <small class="text-danger">*</small>
                      <multiselect v-model="insurance_category" @input="FilterInsuranceService"  :options="servicecategories" label="name" ></multiselect>

                    </div>
                    <div class="form-group mb-2">
                      <label>Service Name</label> <small class="text-danger">*</small>
                      <multiselect v-model="insurance_service" @input="FilterInsurancePrice" label="name"  :options="insurancesservices"></multiselect>

                    </div>
                  
                     <div class="row justify-content-center">
                       <div class="form-group mb-2" >
                      <label>Service Cost</label> <small class="text-danger">*</small>
                      <input v-model="service_price" readonly required type="number" class="form-control" />
                       </div>
                       <br>   <center><span class="text-danger">{{ insurederror }}</span></center>

                      </div>
                    
                    <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')">Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
            </div> 
                   
        </form>
    </template>
</b-modal>




  
      <b-modal id="new-prescription" centered title="New Prescription" title-class="font-18" hide-footer>
          <form @submit.prevent="addPrescription">
            <div class="form-group mb-2">
              <label>Medicine</label>
                <multiselect v-model="medicine" @input="FilterProductUnits" :options="products" label="name"></multiselect>
              </div>
              <div class="row">
              <div class="col-md-6">
              <label>Unit</label>
                <multiselect v-model="unit" @input="FilterPrice" :options="units" label="unit"></multiselect>
                <span class="text-danger"><small>Quantity Left: {{ quantityLeft }}</small></span>

              </div>
              <div class="col-md-6">
              <label>Price</label>
                <input v-model="price" type="number" readonly class="form-control" />
              </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label>Dose</label>
                  <input v-model="dose" type="number"  @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Frequency</label>
                  <input v-model="frequency" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Duration</label>
                  <input v-model="duration" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
              </div>
              <div class="form-group mb-2">
              <label>Total Amount</label>
                <input v-model="totalprice" type="number" readonly class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Prescription Note</label>
              <textarea v-model="note" rows="2" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prescription')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="view-results" centered :title="resultname" title-class="font-14" hide-footer>
          
        <span v-for="item in treatmentresults" :key="item.id">
          <div class="row">
            <div class="col-md-6">
              <span>Presented Complaints <span class="text-info h5" v-html="item.symptoms"></span></span>
              <span>History of Presented Complaints <span class="text-info h5" v-html="item.history"></span></span>
              <span>General Examination to Review of Systems <span class="text-info h5" v-html="item.examination"></span></span>
            </div>
            <div class="col-md-6" style="border-left: 1px solid grey;">
              <span>Provisional Diagnosis <span class="text-info h5" v-html="item.diagnosis"></span></span>
              <span>Recommendation <span class="text-info h5" v-html="item.recommedation"></span></span>
            </div>
          </div>
        </span>
  
      </b-modal>
      <b-modal id="delete-prescription" centered title="Delete Prescription" title-class="font-18" hide-footer>
        <form @submit.prevent="removePrescription">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Prescription : <b>{{ prescriptionname }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-prescription')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>
    <b-modal id="changing-prescription" centered title="Change Prescription" title-class="font-18" hide-footer>
    <form @submit.prevent="changedPrescription">
        <input v-model="id" type="hidden">
        <div>
            Are you sure you want to Change the Prescription : <b>{{ prescriptionname }}</b> ?
        </div>
        <div class="row">
            <div class="col-4">
                <label>Dose</label>
                <input v-model="dose" type="number" @input="CheckMedicine"  min="1" required class="form-control" />
            </div>
            <div class="col-4">
                <label>Frequency</label>
                <input v-model="frequency" type="number"  @input="CheckMedicine"  min="1" required class="form-control" />
            </div>
            <div class="col-4">
                <label>Duration</label>
                <input v-model="duration" type="number" @input="CheckMedicine"  min="1"  required class="form-control" />
            </div>
        </div>
        <br>
        <div class="form-group d-flex justify-content-end">
            <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('changing-prescription')" >Close</b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
    </form>
    </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import Multiselect from "vue-multiselect";
  import { productMethods, productComputed , serviceCategoryMethods,serviceCategoryComputed, insurancesMethods, insurancesComputed , packagesComputed,packagesMethods} from "@/state/helpers";
  
  export default {
    page: {
      title: "Patient Treatment",
      meta: [{name: "description",content: appConfig.description,},],
    },
    components: {
      Layout,Multiselect,
    },
    data() {
      return {
        title: "Patient Treatment",
        items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
        patients:[],
        patientsymptoms:[],
        patientdiseases:[],
        prescriptions:[],
        diagnosis:[],
        symptoms:[],
        services:[],
        newservices:[],
        patientspinner:true,
        patientid:'',
        visitid:'',
        service:'',
        service_id:'',
        recommedation:'',
        examination:'',
        history:'',
        medicine:'',
        price:'',
        quantity:'',
        dose:'1',
        frequency:'1',
        duration:'1',
        note:'',
        units:[],
        unit:'',
        totalprice:'',
        service_category:[],
        service_name:[],
        service_price:'',
        patient_type:'1',
        resultid:'',
        resultname:'',
        treatmentresults:[],
        files:'',
        antenatalcard:[],
        visit_date:'',
        prescriptionname:'',
        payment_types:'',
        insurance_service_name:[],
        insurances:[],
      packages:[],
      insurancespackagescost:[],
      insurancescategory:[],
      insurancesservices:[],
      insurance_company:'',
      insurance_package:'',
      insurance_category:'',
      insurance_service:'',
      insurance_cost:'',
      insurederror:'',
      pay_type:'',
      insuranceservice:'',
        quantityLeft:0,
      };
    },
    computed: {
        ...productComputed,
        ...serviceCategoryComputed,
        ...insurancesComputed,
        ...packagesComputed,
        isPaymentTypeValid() {
          // return !this.services.some(service => service.payment_types === 4);
          return this.pay_type != '4';

         },  

        
    },
    created() {
      this.fetchServiceCategory();
      this.fetchProducts();
      this.fetchInfo();
      this.fetchInsurances();
      this.fetchInsurancePackages();
      // this.FilterInsuranceService();
   
    },
    methods: {
      ...productMethods,
      ...serviceCategoryMethods,
      ...insurancesMethods,
      ...packagesMethods,
    //   getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;    

    return `${years} years `;

  } else {
    return `${months} months old`;
  }
},
      onFileChange(e){
        this.files = e.target.files[0];
      },
      getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"antenatalcards/"+name;
        return imagelink;
      },
      deleti(id,name){
      this.prescriptionid=id;
      this.prescriptionname=name;
      this.$bvModal.show('delete-prescription')
    },
      async edit(id,name){
        this.resultid=id;
        this.resultname=name;
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.resultid}`;
        await axios.get(url).then((response) => {
          this.treatmentresults = response.data.treatments;
        });
        this.$bvModal.show('view-results')
      },
    
      changes(id, name, dosage) {
        this.prescriptionid = id;
        this.prescriptionname = name;

        // Check if dosage is not undefined and has the expected format
        if (dosage && dosage.includes('*')) {
          const [dose, freq, dur] = dosage.split('*').map(part => part.trim());

          // Check if all parts are extracted successfully
          if (dose && freq && dur) {
            this.dose = dose;
            this.frequency = freq;
            this.duration = dur;
          }
        }

        this.$bvModal.show('changing-prescription');
      },
      getPhotos(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"patients/"+name;
            return imagelink;
          },
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/visitinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.visits[0].patient.patient_id;
          this.visitid = response.data.visits[0].visit_id;
       if (response.data.visits[0].service_name?.name) {
      this.service = response.data.visits[0].service_name.name;
       } else if (response.data.visits[0].insurance_service_name?.name) {
      this.service = response.data.visits[0].insurance_service_name.name;
    }
    if ( response.data.visits[0].insurance_service_name ) {
            this.insurance_company = response.data.visits[0].insurance_service_name.insurance_id;
            this.insurance_package = response.data.visits[0].insurance_service_name.package_id;
            this.insurance_categorys = response.data.visits[0].insurance_service_name.category;
            this.insuranceservice =response.data.visits[0].insurance_service_name.name;

          }
          // this.insuranceservice =response.data.visits[0].insurance_service_name.name;

    // this.insurance_company = response.data.visits[0].insurance_service_name.insurance_id;
    // this.insurance_package = response.data.visits[0].insurance_service_name.package_id;
    // this.insurance_categorys = response.data.visits[0].insurance_service_name.category;
     if (response.data.visits[0].service_name?.id) {
     this.service_id = response.data.visits[0].service_name.id;
      } else if (response.data.visits[0].insurance_service_name?.id) {
          this.service_id = response.data.visits[0].insurance_service_name.id;
      }  
      this.pay_type = response.data.visits[0].patientvisit.payment_type;

          this.visit_date = response.data.visits[0].addedon;
          this.showpatient();
          this.showtprescriptions();
          this.showtreatments();
          this.showservices();
          this.showAntenatalcard();
          

        });
      },
      async FilterCategory(){
        let url = `/servicebycategory/${this.service_category.id}`;
          await axios.get(url).then((response) => {
            this.newservices = response.data.services;
          });
      },
      async FilterServicePrice(){
          let url = `/serviceprice/${this.service_name.id}`;
          await axios.get(url).then((response) => {
            this.service_price = response.data.price;
            });
        },
      CheckMedicine(){
        this.totalprice = this.price*this.dose*this.frequency*this.duration;
      },
      async FilterProductUnits(){
          let url = `/unitsbyproduct/${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.units = response.data.units;
            });
        },
      async FilterPrice(){
          let url = `/productbyunitprice/${this.unit.unit_id},${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.price = response.data.price;
            if (this.unit ) {
        this.quantityLeft = this.unit.product.quantity;
      }
            this.CheckMedicine();
            });
        },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async showservices(){
        let url = `/profileservices/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.services = response.data.visits;

        });
      },
      async showAntenatalcard(){
        let url = `/antenatalcard/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.antenatalcard = response.data.card;
        });
      },
      async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtreatments(){
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.service_id}`;
        await axios.get(url).then((response) => {
        if (response.data.treatments.length===0) {
          this.symptoms = '';
          this.history = '';
          this.examination = '';
          this.diagnosis = '';
          this.recommedation = '';
        }else{
          this.symptoms = response.data.treatments[0].symptoms;
          this.history = response.data.treatments[0].history;
          this.examination = response.data.treatments[0].examination;
          this.diagnosis = response.data.treatments[0].diagnosis;
          this.recommedation = response.data.treatments[0].recommedation;
          this.patient_type = response.data.treatments[0].patient_type;
        }
        });
      },
      async addAntenatalCard(){
        let formData = new FormData();
          formData.append("patient_id", this.patientid);
          formData.append("visit_id", this.visitid);
          formData.append("file", this.files);
          let url = "/addantenatalcard";
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.showAntenatalcard();
              this.files="";
              this.$toast.success(response.message);
          }
          });
      },
      async AddPatientService() { 
          let formData = new FormData();
          formData.append("patient_id", this.patientid);
          formData.append("visit_id", this.visitid);
        
        formData.append("service_price", this.service_price);
        formData.append("service_category", this.service_category?.id ?? this.cat_id ?? 0);
        // formData.append("service_category", this.service_category.id ? this.service_category.id : 0);
        formData.append("service_name", this.service_name.id ? this.service_name.id : 0);
        formData.append("insurance_company", this.insurance_company? this.insurance_company: 0);
        formData.append("insurance_category", this.insurance_category.id ? this.insurance_category.id : 0);
        formData.append("insurance_package", this.insurance_package ? this.insurance_package : 0);
        formData.append("insurance_service", this.insurance_service.id ? this.insurance_service.id : 0);

          let url = "/addpatientvisit";
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.showservices();
              this.$bvModal.hide('new-service');
              this.service_category="";
              this.service_name="";
              this.service_price="";
              // this.insurance_company="";
            this.insurance_category="";
            // this.insurance_package="";
            this.insurance_service="";
              this.$toast.success("New Patient Service Added");
          }
          });
        },
      async addTreatment() { 
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("service_id", this.service_id);
        formData.append("symptoms", this.symptoms);
        formData.append("history", this.history);
        formData.append("examination", this.examination);
        formData.append("recommedation", this.recommedation);
        formData.append("diagnosis", this.diagnosis);
        formData.append("patient_type", this.patient_type);
  
        let url = "/addtreatment";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.showtreatments();
          this.showservices();
            this.symptoms="";
            this.history="";
            this.examination="";
            this.recommedation="";
            this.diagnosis="";
            this.patient_type="1";
            this.$toast.success("Patient Treatment Added");
        }
        });
      },
      async addPrescription() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("service_id", this.service_id);
        formData.append("medicine", this.medicine.id);
        formData.append("unit", this.unit.unit_id);
        formData.append("dosage", this.dose+" * "+this.frequency+" * "+this.duration );
        formData.append("quantity", this.dose*this.frequency*this.duration );
        formData.append("totalprice", this.totalprice);
        formData.append("note", this.note);
        let url = "/addprescription";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-prescription');
            this.showtprescriptions();
            this.medicine="";
            this.dose="";
            this.frequency="";
            this.duration="";
            this.note="";
            this.$toast.success("Patient Prescription Added");
        }
        });
      },

      async changedPrescription() {
  let formData = new FormData();
  formData.append("prescription_id", this.prescriptionid);
  formData.append("dose", this.dose);
  formData.append("frequency", this.frequency);
  formData.append("duration", this.duration);
  formData.append("dosage", this.dose+" * "+this.frequency+" * "+this.duration );

  let url = "/changeprescription";

  await axios.post(url, formData).then((response) => {
    if (response.status == 200) {
      this.$bvModal.hide('changing-prescription');
      this.showtprescriptions();
      this.dose = ""; // Clear the dose after submission
      this.frequency = ""; // Clear the frequency after submission
      this.duration = ""; // Clear the duration after submission
      this.dosage = "";
      this.$toast.success("Patient Prescription Changed");
    }
  });
},
      async removePrescription() { 
    let formData = new FormData();
    formData.append("prescriptionid", this.prescriptionid);
    let url = "/removepatientprescription";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.showtprescriptions();
        this.$bvModal.hide('delete-prescription');
      }
    });
    },
   
      async FilterInsurancePackage() {

        let url = `/packagebyinsurance/${this.insurance_company.id}`;

          await axios.get(url).then((response) => {

            this.insurancespackagescost = response.data.insurancespackagescost;
          })

        },

      async FilterInsuranceCategory() {

      let url = `/categorybyinsurance/${this.insurance_package}`;

          await axios.get(url).then((response) => {

            this.insurancescategory = response.data.insurancescategory;
      })

      },

      async FilterInsuranceService( ) {

      //  let url = `/servicebyinsurance/${this.insurance_category.id},${this.insurance_package.id}`;
      let url = `/servicebyinsurance/${this.insurance_category.id},${this.insurance_package}`;

          await axios.get(url).then((response) => {

            this.insurancesservices = response.data.insurancesservices;
        })

      },

      async FilterInsurancePrice(){
                  let url = `/insuranceprice/${this.insurance_service.id}`;
                  await axios.get(url).then((response) => {
                    this.service_price = response.data.insuranceprice;
                    if (response.data.insuranceprice=='') {
                      this.insurederror = "Service not offered on this Insurance category"; 
                    } else{
                      this.insurederror = "";
                    }
                    
                    });

                    
                },
          },


  };
  </script>